export default __webpack_public_path__ + "static/media/my-needs-icon-active-old.a87091c9.svg";